import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

/**
 * IsInteractiveSection (presentational)
 * - Render radio "Apakah soal interaktif"
 * - Parent tetap pegang dispatch/logic
 */
export default function IsInteractiveSection(props) {
  const { value, onSetFalse, onSetTrue, isDisabled } = props;

  // Support value boolean atau number-like (karena di code ada compare `== 1`)
  const isYes = value === true || value == 1;
  const isNo = value === false || value == 0;

  return (
    <FormGroup className="mb-3">
      <Label style={{ fontWeight: 'bold' }}>{'Apakah soal interaktif'}:</Label>

      <div className="m-checkbox-inline">
        <Label for="is_interactive_false">
          <Input
            className="radio_animated"
            id="is_interactive_false"
            type="radio"
            name="is_interactive"
            value="0"
            checked={isNo}
            onChange={onSetFalse}
            disabled={isDisabled}
          />
          {'Tidak'}
        </Label>

        <Label for="is_interactive_true">
          <Input
            className="radio_animated"
            id="is_interactive_true"
            type="radio"
            name="is_interactive"
            value="1"
            checked={isYes}
            onChange={onSetTrue}
            disabled={isDisabled}
          />
          {'Ya'}
        </Label>
      </div>
    </FormGroup>
  );
}